// HealthMail directory titles each picker lists (KIN-2211). Not "GP%": that pattern would
// also match "GP Support", which is practice staff mailboxes rather than doctors.

export const PHARMACY_CONTACT_TITLES = ["Pharmacy"];

export const REFERRER_CONTACT_TITLES = [
  "GP",
  "GP with Special Interest",
  "Private Consultant",
  "Doctor (Private Consultant)",
  "Doctor (Virtual Healthcare)",
];

export const PRIMARY_GP_CONTACT_TITLES = ["GP", "GP with Special Interest"];
